import { render, staticRenderFns } from "./StatusIconSberMarket.vue?vue&type=template&id=ef75883c&scoped=true&"
import script from "./StatusIconSberMarket.vue?vue&type=script&lang=js&"
export * from "./StatusIconSberMarket.vue?vue&type=script&lang=js&"
import style0 from "./StatusIconSberMarket.vue?vue&type=style&index=0&id=ef75883c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef75883c",
  null
  
)

export default component.exports